import { Observable } from 'rxjs';

import { UseCase }
from '../../base/use-case';

import { PerfilMenuModel, DataPerfilMenuModel }
from '../../models/configuration/perfil-menu.model';

import { ConfigurationRepository }
from '../../repositories/configuration.repository';

export class InsertPerfilMenuUseCase implements UseCase< DataPerfilMenuModel, PerfilMenuModel > {

    constructor(
        private repository:
        ConfigurationRepository
    ) {}

    execute(
        request: DataPerfilMenuModel
    ):
    Observable<PerfilMenuModel> {

        return this.repository
            .insertPerfilMenu(
                request
            );
    }
}